import ThemeBackground from "@pathwright/ui/src/components/background/ThemeBackground"
import Portal from "@pathwright/ui/src/components/portal/Portal"
import PathwrightUI from "@pathwright/ui/src/components/ui/PathwrightUI"
import { ConnectStores } from "lib/core/store"
import { DESIGN } from "path/constants"

const LibraryResourceTheme = ({
  children,
  resource,
  offering,
  section,
  mode
}) => {
  const isSource = !!offering && offering.is_curriculum
  const theme = resource
    ? {
        backgroundImage: resource.background_image_blurred_cdn,
        backgroundOverlay: resource.background_overlay,
        backgroundDots: isSource && mode === DESIGN
      }
    : {
        // If the resource is not available yet, we still want to override the defualt
        // theme as this prevents a flash of default theme background image when transitioning
        // between resources (like when going from a collection path to a child cohort path).
        backgroundImage: null,
        backgroundOverlay: null
      }

  return (
    <PathwrightUI.Provider theme={theme}>
      {section !== "about" && (
        <>
          <Portal portalElementID="theme-portal">
            <ThemeBackground zoom={isSource} />
          </Portal>
        </>
      )}
      {children}
    </PathwrightUI.Provider>
  )
}

LibraryResourceTheme.displayName = "LibraryResourceTheme"

const mapStateToProps = function (state, ownProps) {
  const { resource, offering, section } = state.resourceStore.state
  const { mode } = state.pathStore.state

  const props = {
    ...ownProps,
    resource,
    offering,
    section,
    mode
  }

  return props
}

const stores = [
  { store: "resource", watch: ["resource", "section"] },
  { store: "path", watch: ["mode"] }
]

export default ConnectStores(LibraryResourceTheme, stores, {}, mapStateToProps)
